module.exports = __webpack_public_path__ + "img/40_69_003_710.7277028e.jpg";